export enum LoginTypes {
	phone = 'phone',
	email = 'email',
}
